import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import { UnderlineButton } from 'Components/ComponentLibrary/Atoms/UnderlineButton';

export const BeneficiaryTypeInput = ({
  value, onChange, options,
}) => {
  return (
    <FDStack>
      {options.filter(opt => opt.id !== value).map(opt => {
        return (
          <UnderlineButton
            key={opt.id}
            label={`Switch to ${opt.prompt.toLowerCase()} beneficiary`}
            onClick={() => {
              onChange(opt.id);
            }}
          />
        );
      })}
    </FDStack>
  );
};

BeneficiaryTypeInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};
